import React, { useContext, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppContext } from '@prisjakt/ui-app-context';
import { TranslateFunc } from '@prisjakt/ui-translate/src/translate-func';
import { ProductCondition } from '../../../../types';
import { trackPriceListFilterUpdate } from '../tracking';
import { PriceListFilterContext } from '../../price-list-filter-context';
import RouteContext from '../../../../routes/context';
import { AppState } from '../../../../reducers';
import PriceRange from '../price-range';
import { getConditions, getUsedTypes } from './utils';
import { IProductCondition, IProductConditionsProps } from './types';
import { setSelectedCondition } from '../../actions/product';
import * as S from './styles';

const ProductConditions: React.FC<IProductConditionsProps> = props => {
  const { filters, selectedCondition } = useContext(PriceListFilterContext);

  const priceDisplay = useSelector(
    (state: AppState) => state.areas.product.priceDisplay
  );
  const dispatch = useDispatch();
  const { dispatch: routeDispatch } = useContext(RouteContext);
  const { t } = useContext(AppContext);
  const instanceId = useRef(Math.random()); // Since this is used inside media queries, we get aria failiures on non-unique keys without this

  const handleSelectedCondition = (cond: IProductCondition) => {
    dispatch(setSelectedCondition(cond.name));
    trackPriceListFilterUpdate(cond.name, false);

    routeDispatch({
      type: 'PRODUCT_CONDITION',
      options: filters,
      condition: cond.name,
    });
  };

  const conditions = getConditions(props.conditions, priceDisplay);
  const usedTypes = getUsedTypes(props.conditions);

  return usedTypes && usedTypes.count > 0 ? (
    <S.VariantGroupWrapper>
      <S.VariantGroup>
        {conditions.map(condition => {
          const key = `${condition.name}-${instanceId.current}`;
          const name = `${getConditionName(condition.name, t)} (${
            condition.count
          })`;

          return (
            <S.SelectableButton
              key={key}
              handleOnClick={() => handleSelectedCondition(condition)}
              title={name}
              id={key}
              name="condition"
              selected={condition.name === selectedCondition}
              ariaLabel={name}
              subtitle={
                <PriceRange priceFrom={condition.from} priceTo={condition.to} />
              }
              type="radio"
              maxWidth={250}
            />
          );
        })}
      </S.VariantGroup>
    </S.VariantGroupWrapper>
  ) : null;
};

const getConditionName = (type: ProductCondition, t: TranslateFunc): string => {
  switch (type) {
    case 'used':
      return t('product', 'price-filter.used-short');
    case 'new':
    default:
      return t('product', 'price-filter.new');
  }
};

export default ProductConditions;
